import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons'
import { sumAndFormat } from '@shared/libs/sumAndFormat'
import { Collapse, Typography } from 'antd'
import { useMemo } from 'react'
import { useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

const { Panel } = Collapse
const { Text } = Typography

export function FieldActionsLeft() {
  const { t } = useTranslation()

  const cpreparationFee = useWatch({ name: 'commission.preparationFee' })
  const cissueFee = useWatch({ name: 'commission.issueFee' })

  const preparationFee = useMemo(
    () => Number(cpreparationFee || 0).toFixed(2),
    [cpreparationFee]
  )
  const issueFee = useMemo(() => Number(cissueFee || 0).toFixed(2), [cissueFee])

  const totalFee = useMemo(
    () => sumAndFormat(cpreparationFee, cissueFee),
    [cpreparationFee, cissueFee]
  )

  return (
    <>
      <Collapse
        defaultActiveKey={['1']}
        bordered={false}
        expandIconPosition="end"
        style={{
          background: '#F3F6FA',
          borderRadius: 8,
          padding: 0,
        }}
        expandIcon={({ isActive }) =>
          isActive ? (
            <CaretUpOutlined style={{ fontSize: 14, color: '#000' }} />
          ) : (
            <CaretDownOutlined style={{ fontSize: 14, color: '#000' }} />
          )
        }
      >
        <Panel
          header={
            <>
              <Text strong style={{ fontSize: 16 }}>
                {t('businessCardOrders.labels.totalPay')}:
              </Text>
              <Text strong style={{ fontSize: 16 }}>
                {' '}
                {totalFee} AZN
              </Text>
            </>
          }
          key="1"
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: 8,
            }}
          >
            <Text type="secondary">
              {t('orders.salaryCardOrder.tableTitles.orderTypes')}:
            </Text>
            <Text strong>{preparationFee} AZN</Text>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Text type="secondary">
              {t('businessCardOrders.labels.issueFree')}:
            </Text>
            <Text strong>{issueFee} AZN</Text>
          </div>
        </Panel>
      </Collapse>
    </>
  )
}
